import axios from "axios";
import compatibleStore from "store";
var fontDelta = compatibleStore.get("list-font-size");
if (!fontDelta) {
	compatibleStore.set("list-font-size", 0);
}
const state = {
	
	defaultFontSize: 0.85,
    displayedFontSize: 0.85 + compatibleStore.get("list-font-size"),

};

const actions = {

    async updateListFontSize(context, size){
		context.commit("setListFontSize",size)
	},
	
}

const mutations = {
	setListFontSize(state,size){
		state.displayedFontSize = size;
	},
}

const getters = {
	displayedFontSize(state){
		return state.displayedFontSize;
	},
};
  

export default {
    state,
    actions,
    mutations,
    getters
};